import { http } from "../../../common/http";

export const getDistributorDetail = (title: string) => {
    return http({
        url: `/distributor/0`,
        method: "GET",
        params: {
            title
        }
    })
}